// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__Aik4Y","footer":"ModalCreateQualiphyProcedure_footer__15dTp","additionData":"ModalCreateQualiphyProcedure_additionData__2Pap5"};